export default __webpack_public_path__ + "static/dashboard-0e6821f0a6475f31bafc4f7b9d2e72f0.png";